define ['./personal_info.css'], () ->
  ($scope, $rootScope, $state,  $stateParams, RentappService, RENTAPPLICATION_API_URL, Flash, hotkeys, $http, $location, $anchorScroll, $timeout) ->
    $scope.secure_svg = require('./../secure.svg')
    $scope.pid_data = {}
    $scope.context = $stateParams.context
    $scope.application = $stateParams.application

    $scope.vendor_name = if $stateParams.vendor == 'smartmove' then 'Transunion' else 'Experian'

    $scope.states = ['AL', 'AK', 'AZ',
                      'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA',
                      'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA',
                      'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT',
                      'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND',
                      'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN',
                      'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY']

    hotkeys.bindTo($scope).add
      combo: 'ctrl+8',
      description: 'Fill PID with sample data'
      callback: () ->
        console.log "ctrl 8"
        $scope.fill_sample_data()

    $scope.fill_sample_data = () ->
      $scope.pid_data =
         firstName:       "Akkaya"
         lastName:        "Jorge"
         ssn:             "666720909"
         currentAddress:  "32 brook st"
         currentCity:     "Patchogue"
         currentState:    "NY"
         currentZip:      "11772"

    $scope.set_current_state = (state) ->
      $scope.pid_data.currentState = state

    $scope.submit_personal_info = () ->
      $scope.loading_questions = true
      if $scope.vendor_name == 'Transunion'
        $state.go('root.verifications.questions', {landlord_data: $scope.pid_data }) 
        $scope.loading_questions = false
      else
        if $scope.context == 'applicant'
          $scope.pid_data.application_id = $scope.application.id
        $http.get "#{RENTAPPLICATION_API_URL}/api/v1/reportsourceprofile/experian_questions/?#{$scope.context}=true", params: $scope.pid_data
          .then (response) ->
            if $scope.context == 'landlord'
              $state.go('root.verifications.questions', { questions: response.data, context: $scope.context })
            else if $scope.context == 'applicant-payment'
              $state.go('root.payment.verify.questions', { questions: response.data })
            else
              $state.go('root.applications.verify.questions', { questions: response.data, application: $scope.application })
          .catch (response) ->
            $scope.error = response.data

            if response.data.code == "max_attempts_reached"
              if $scope.context == 'landlord'
                $state.go('root.verifications.verify_fail')
              else if $scope.context == 'applicant-payment'
                $state.go('root.payment.verify.verify_fail')
              else
                $state.go('root.applications.verify.verify_fail',  { application: $scope.application })
            else
              Flash.create("danger", response.data.message, 10000, { class: 'step2-error active'}, true)
              $timeout () ->
                $location.hash('error_messge')
                $anchorScroll()

          .finally () ->
            $scope.loading_questions = false



// WEBPACK FOOTER //
// ./components/verifications/personal_info/personal_info.coffee